// Mock data for EPG Croatia Landing Page - Croatian Only

export const mockDataHrvatski = {
  header: {
    logoText: "EPG Hrvatska",
    buttons: [
      { text: "Rezerviraj poziv", type: "outline" },
      { text: "Privatnost", type: "outline" }
    ]
  },
  hero: {
    badge: "Ulažemo u plemenite metale od 2015. godine",
    headline: "Ulagajte u zlato i srebro po svojim uvjetima!",
    subheading: "Dobrodošli u Electrum Prosperity Group Hrvatska!",
    benefits: [
      "Ovlašteni distributer plemenitih metala u skladu s propisima",
      "Sigurno skladištenje i posvećene logističke usluge",
      "Bonus u zlatu za potvrđene preporuke",
      "Jednostavna platforma za upravljanje izravno s telefona"
    ],
    stats: [
      { value: "+$80", label: "u zlatu", sublabel: "za svaku preporuku" },
      { value: "$500", label: "Gotovina", sublabel: "nagrada" },
      { value: "$820", label: "Ukupno", sublabel: "potencijal" },
      { value: "Tjedno", label: "Isplate", sublabel: "" }
    ],
    ctas: [
      { text: "Rezerviraj poziv", type: "primary" },
      { text: "Pridruži se!", type: "secondary" }
    ],
    email: "electrumpg@gmail.com",
    videoUrl: "https://www.7kmetals.com/stusimonsen/share/xyt25"
  },
  features: [
    {
      title: "Preporuči 4 prijatelja = 820 USD",
      description: "Zaradite 320 USD u čistom zlatu (4 x 80 USD) + 500 USD u novčanim nagradama. Više od cijene Legacy članstva."
    },
    {
      title: "Jeste li spremni za početak?",
      description: "Ako ste spremni započeti, pružamo potpunu obuku. Nije potrebno prethodno iskustvo."
    },
    {
      title: "Saznaj više!",
      description: ""
    }
  ],
  contactForm: {
    title: "Kontaktirajte nas",
    fields: [
      { name: "name", placeholder: "Ime i prezime", type: "text" },
      { name: "email", placeholder: "E-mail", type: "email" },
      { name: "phone", placeholder: "Telefon", type: "tel" }
    ],
    submitText: "Pošalji i obavijesti me",
    privacyText: "Pristajem da me kontaktirate. Pogledajte",
    privacyLink: "Politiku privatnosti"
  },
  footer: {
    copyright: "© 2025 EPG Hrvatska",
    email: "electrumpg@gmail.com",
    cta: "Spremni ste započeti svoje putovanje s EPG-om?",
    ctaButton: "Pridruži se!"
  },
  videos: {
    title1: "Strategije rasta bogatstva",
    title2: "Ubrzavanje rasta bogatstva"
  },
  messages: {
    privacyError: "Morate prihvatiti politiku privatnosti.",
    submitSuccess: "Hvala! Obrazac je uspješno poslan. Uskoro ćemo vas kontaktirati.",
    submitError: "Došlo je do pogreške. Molimo pokušajte ponovno.",
    linkError: "Nije moguće dobiti link za prijavu. Molimo kontaktirajte nas.",
    sending: "Slanje..."
  }
};
